<script setup>
import { ref } from 'vue';

const show = ref(false);

const closeModal = () => {
  show.value = false;
  document.querySelector('body')?.classList.remove('overflow-hidden');
};

const openModal = () => {
  show.value = true;
  document.querySelector('body')?.classList.add('overflow-hidden');
};

defineExpose({
  openModal,
  closeModal
});
</script>

<template>
  <transition name="fade">
    <div v-if="show" class="modals">
      <div class="modals__backdrop" @click="closeModal" />
      <div class="modals__dialog">
        <div class="modals__header">
          <slot name="header" />
        </div>
        <div class="modals__body">
          <slot name="body" />
        </div>
        <div class="modals__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.modals {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;

  &__backdrop {
    background-color: rgba(0, 0, 0, 0.45);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &__dialog {
    background-color: #ffffff;
    position: relative;
    width: 90%;
    max-width: 780px;
    margin: 30px auto;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    z-index: 2;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.25), 0 8px 10px -6px rgba(0, 0, 0, 0.2);
    @media screen and (max-width: 992px) {
      width: 92%;
      margin: 20px auto;
    }
    @media screen and (max-width: 550px) {
      width: 96%;
      margin: 15px auto;
    }
  }
  &__header {
    padding: 14px 20px;
    display: block;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 1px solid #e9ecef;

    :deep(.close) {
      cursor: pointer;
      background: transparent;
      border: none;
      font-size: 24px;
      line-height: 1;
      color: #6c757d;
      padding: 0;
      margin: 0;
      transition: color 0.15s ease-in-out;
      &:hover {
        color: #212529;
      }
    }
  }
  &__body {
    padding: 16px 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    padding: 12px 20px 20px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>